import { Box, Card, Typography } from '@mui/material';
import { useL10n } from '@uplift/hooks';

import { useSupportPageStyles } from './support-page-styles';
import { useCurrentuser } from '@uplift/contexts';
import { UserRole } from '@uplift/types';

export const SupportEmailCard: React.VFC = () => {
  const l10n = useL10n();
  const me = useCurrentuser();
  const { classes } = useSupportPageStyles();

  return (
    <Box className={classes.gridItem}>
      <Card className={classes.cardRight}>
        <Typography variant="h4" color="secondary" className={classes.cardTitle}>
          {l10n.support.email}
        </Typography>
        <Box color="darkSlate" mt={4}>
          <Typography variant="h4" className={classes.supportNumber}>{me.role === UserRole.externalAdmin ? l10n.support.supportEmailOrg : l10n.support.supportEmail}</Typography>
        </Box>
      </Card>
    </Box>
  );
};
